var carousel = (function($) {
    return {
        windowWidth: $(window).width(),
        windowHeight: $(window).height(),
        interVal: '',

        // Initial function
        init: function() {
            // Define the parent selector this variable
            var _this = this;
            _this.bindEvents();
            _this.windowEvents();
            _this.interVal1();
        },
        interVal1: function() {
            var _this = this;

            if(($('.carousel-wrapper li').size() > 1)) {
            }
            if($('.carousel-nubbins ul li').length <= 1) {
                $('.carousel-nubbins').hide();
            }
        },
        clearInterval: function() {
            var _this = this;

            if(_this.windowWidth >= 768) {
                clearInterval(_this.interVal);
            }
        },
        bindEvents: function() {
            var _this = this;

            $('.carousel-nubbins ul li').click(function() {
                _this.clearInterval();

                var index = $(this).index();

                $('.carousel-nubbins ul li').removeClass('selected');
                $(this).addClass('selected');

                $('.carousel-wrapper ul li').animate({
                    //opacity: 0
                }, 500);

                $('.carousel-wrapper ul li').removeClass('selected');

                $('.carousel-wrapper ul li:eq('+index+')').animate({
                    //opacity: 1
                }, 500);

                $('.carousel-wrapper ul li:eq('+index+')').addClass('selected');

                _this.interVal1();
            });
        },
        windowEvents: function() {
            var _this = this;

            $(window).resize(function() {
                _this.windowWidth = $(window).width();
                _this.windowHeight = $(window).height();
            });

            $(window).scroll(function() {

            });
        },
        autoPlay: function() {
            var _this = this;

            if(($('.carousel-wrapper ul li').length > 1)) {

                var nextSlide = $('.carousel-wrapper ul li.selected').next('li');
                var nextThumb = $('.carousel-nubbins ul li.selected').next('li');

                if(nextSlide.length === 0) {
                    nextSlide = $('.carousel-wrapper ul li:first-child');
                    nextThumb = $('.carousel-nubbins ul li:first-child');
                }

                $('.carousel-wrapper ul li.selected').animate({
                    //opacity: 0
                }, 500);

                $('.carousel-wrapper ul li.selected').removeClass('selected');
                $('.carousel-nubbins ul li.selected').removeClass('selected');

                nextSlide.animate({
                    //opacity: 1
                }, 500);

                nextSlide.addClass('selected');
                nextThumb.addClass('selected');
            }
        }
    };
})(jQuery);

//Document on load
jQuery(document).ready(function($) {
    // initialize the FP function
    carousel.init();
});
